import { render, staticRenderFns } from "./ProductTabLinks.vue?vue&type=template&id=12efe430&"
import script from "./ProductTabLinks.vue?vue&type=script&lang=js&"
export * from "./ProductTabLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports